import { MakePaths } from "common/router/types";
import { MakeRoutesOpts } from "common/router/utils/routes";
import { makeUrls } from "common/router/utils/urls";

import { INITIAL_CLIENT_DATA } from "client/common/utils";
import { makeClientRoutes } from "client/routes/types";

import { HelpCenterSearch } from "../types";

const paths = {
  helpCenter: "/",
  privacyPolicy: "/privacy-policy",
  termsOfUse: "/terms-of-use",
  autoshipTerms: "/autoship-terms",
};

type SupportPathDefinitions = {
  helpCenter: { Search: HelpCenterSearch };
  privacyPolicy: {};
  termsOfUse: {};
  autoshipTerms: {};
};

export type SupportPaths = MakePaths<SupportPathDefinitions>;

export const useSupportRoutes = (opts: MakeRoutesOpts) => {
  const isHdEnabled = INITIAL_CLIENT_DATA.clinic.primary_tag.is_hd_enabled;

  const routes = [
    {
      path: paths.helpCenter,
      element: () => import("../components/SupportPage"),
      requiresHd: true,
      pageName: "support",
    },
    {
      path: paths.privacyPolicy,
      element: () => import("../components/PrivacyPolicyPage"),
      pageName: "privacy_policy",
    },
    {
      path: paths.termsOfUse,
      element: () => import("../components/TermsOfUsePage"),
      pageName: "terms_of_use",
    },
    {
      path: paths.autoshipTerms,
      element: () => import("../components/AutoshipTermsPage"),
      pageName: "autoship_terms",
    },
  ];

  const filteredRoutes = routes.filter((route) => !route.requiresHd || isHdEnabled);

  return makeClientRoutes(opts, filteredRoutes);
};

export const makeSupportUrls = (base: string) => {
  return makeUrls<SupportPathDefinitions>(base, {
    helpCenter: { path: paths.helpCenter },
    privacyPolicy: { path: paths.privacyPolicy },
    termsOfUse: { path: paths.termsOfUse },
    autoshipTerms: { path: paths.autoshipTerms },
  });
};
